import type { TFunction } from 'i18next'

/**
 * Resolves a navigation-model string through the `nav` namespace (TASK-505148A8,
 * batch contract C-5). `fallback` is the model's EN literal: it is returned
 * verbatim when there is no key (a DATA heading — the engagement's client name)
 * and is the `defaultValue` when a key has no resource.
 */
export const navText = (t: TFunction, key: string | undefined, fallback: string): string =>
  key === undefined ? fallback : t(key, { ns: 'nav', defaultValue: fallback })
